// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Layout from "../utils/core/Layout";
// import { useForm } from "react-hook-form";
// import {
//   DJANGO_CLIENT_ID,
//   DJANGO_SECRET_ID,
//   LINKEDIN_REDIRECT_URL,
// } from "../../BackendConnections";
// import { useLocation } from "react-router-dom";
// import { useLinkedIn } from "react-linkedin-login-oauth2";
// import {
//   signInAction,
//   socialLoginAction,
// } from "../../redux/actions/authentication/authenticationAction";
// import ReactLoading from "react-loading";
// import { connect } from "react-redux";

// export const SignIn = (props) => {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm();

//   const [showPassword, setShowPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   const navigate = useNavigate();
//   const location = useLocation();

//   // useEffect(() => {
//   //     if (localStorage.getItem('access_token') && props.is_user === true) {
//   //         navigate('/user/dashboard')
//   //     }
//   // }, [props, navigate]);

//   // Form submission handling.
//   const onSubmit = (data, event) => {
//     event.preventDefault();
//     const authentication = {
//       username: data.email.toLowerCase(),
//       password: data.password,
//       grant_type: "password",
//       client_id: DJANGO_CLIENT_ID,
//       client_secret: DJANGO_SECRET_ID,
//     };

//     if (Object.keys(errors).length === 0) {
//       // setIsLoading(!isLoading)
//       props.signIn(authentication, navigate);
//     }
//   };

//   const { linkedInLogin } = useLinkedIn({
//     clientId: "86jn3pqhdopvtf",
//     redirectUri: LINKEDIN_REDIRECT_URL,
//     scope: "r_emailaddress r_liteprofile",
//     onSuccess: (code) => {
//       props.socialSignin(code, navigate);
//       setIsLoading(!isLoading);
//     },
//     onError: (error) => {
//       this.setState({
//         error: "Invalid Email / Invalid Password",
//       });
//     },
//   });

//   return (
//     <div className="login-page">
//       {isLoading ? (
//         <div
//           style={{
//             width: "100vw",
//             height: "100vh",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             position: "absolute",
//             top: 0,
//             left: 0,
//             zIndex: "9999",
//             opacity: 0.5,
//           }}
//         >
//           <ReactLoading type={"bars"} color="#1D2552" />
//         </div>
//       ) : (
//         ""
//       )}
//       <Layout>
//         <main>
//           <section className="login-area">
//             <div className="container">
//               <div className="row">
//                 <div className="col-md-6 mini-7">
//                   <div className="inner-content features-list-block">
//                     <h2>
//                       Welcome to <br />a new era
//                     </h2>
//                     <p>
//                       {/* Intro to the log in / sign up if required. Intro to the
//                       log in / sign up if required. Intro to the log in / sign
//                       up if required.{" "} */}

//      Log In and continue to enhance your prospects and your energy
//      sector journey.
//                     </p>
//                     <ul className="features-list">
//                       <li className="text-center">
//                         <div className="img-wrap text-center">
//                           <img
//                             src="/assets/images/icons/profile.svg"
//                             alt="neet"
//                           />
//                         </div>
//                         <div className="feature-name">
//                           MY <strong>Profile</strong>
//                         </div>
//                       </li>
//                       <li className="text-center">
//                         <div className="img-wrap text-center">
//                           <img
//                             src="/assets/images/icons/analytics.svg"
//                             alt="neet"
//                           />
//                         </div>
//                         <div className="feature-name">
//                           MY <strong>Analytics</strong>
//                         </div>
//                       </li>
//                       <li className="text-center">
//                         <div className="img-wrap text-center">
//                           <img
//                             src="/assets/images/icons/network.svg"
//                             alt="neet"
//                           />
//                         </div>
//                         <div className="feature-name">
//                           MY <strong>Network</strong>
//                         </div>
//                       </li>
//                       <li className="text-center">
//                         <div className="img-wrap text-center">
//                           <img
//                             src="/assets/images/icons/performance.svg"
//                             alt="neet"
//                           />
//                         </div>
//                         <div className="feature-name">
//                           MY <strong>Performance</strong>
//                         </div>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="col-md-6 mini-5">
//                   <div className="login-form">
//                       {/* Display a success message if present in the location state. */}
//                     {location.state && (
//                       <p style={{ color: "green", fontSize: "14px" }}>
//                         {location.state.Message}
//                       </p>
//                     )}
//                     <h5>Log In to Your Account</h5>
//                     {/* Display an error message if there's a sign-in error from Redux state. */}
//                     {props.signInError && (
//                       <p style={{ color: "red", fontSize: "14px" }}>
//                         {props.signInError.error_description}
//                       </p>
//                     )}
//                      {/* Form handling using react-hook-form onSubmit event. */}
//                     <form onSubmit={handleSubmit(onSubmit)}>
//                       <div className="input-group">
//                         <input
//                           type="email"
//                           className="form-control"
//                           id="email"
//                           name="email"
//                           placeholder="Email"
//                           autoComplete="off"
//                           {...register("email", {
//                             required: "Email is Required",
//                             pattern: {
//                               value:
//                                 /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
//                               message: "Email is not Valid",
//                             },
//                           })}
//                         />
//                       </div>
//                        {/* Display validation error for the email input. */}
//                       {errors.email ? (
//                         <p style={{ color: "red", fontSize: "14px" }}>
//                           {errors.email?.message}
//                         </p>
//                       ) : (
//                         ""
//                       )}
//                       <div className="input-group table-group">
//                         <input
//                           type={showPassword ? "text" : "password"}
//                           className="form-control"
//                           id="password"
//                           name="password"
//                           placeholder="Password"
//                           autoComplete="off"
//                           {...register("password", {
//                             required: "Password is Required",
//                           })}
//                         />
//                         <div className="input-group-append">
//                           <Link
//                             to=""
//                             onClick={() => setShowPassword(!showPassword)}
//                             className="btn btn-outline-secondary"
//                           >
//                             Show
//                           </Link>
//                         </div>
//                       </div>
//                       {errors.password ? (
//                         <p style={{ color: "red", fontSize: "14px" }}>
//                           {errors.password?.message}
//                         </p>
//                       ) : (
//                         ""
//                       )}

//                       <div className="login-linkedin">
//                         <button type="submit" className="btn btn-secondary">
//                           Log in
//                         </button>
//                         &nbsp;
//                         <Link
//                           to="/forgetPassword"
//                           style={{
//                             color: "red",
//                             display: "flex",
//                             justifyContent: "flex-end",
//                             textDecoration: "underline",
//                           }}
//                         >
//                           Forgot Password
//                         </Link>
//                       </div>
//                     </form>
//                     <h5>REGISTER FOR AN ACCOUNT</h5>
//                     <Link to="/signup" className="btn btn-signup">
//                       Sign up
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>
//           <section className="img-list">
//             <div className="container-fluid">
//               <div className="row">
//                 <div className="col">
//                   <figure>
//                     <img
//                       className="img-fluid w-100"
//                       src="/assets/images/img2.png"
//                       alt="neet"
//                     />
//                   </figure>
//                 </div>
//                 <div className="col">
//                   <figure>
//                     <img
//                       className="img-fluid w-100"
//                       src="/assets/images/img3.png"
//                       alt="neet"
//                     />
//                   </figure>
//                 </div>
//                 <div className="col">
//                   <figure>
//                     <img
//                       className="img-fluid w-100"
//                       src="/assets/images/img4.png"
//                       alt="neet"
//                     />
//                   </figure>
//                 </div>
//                 <div className="col">
//                   <figure>
//                     <img
//                       className="img-fluid w-100"
//                       src="/assets/images/img5.png"
//                       alt="neet"
//                     />
//                   </figure>
//                 </div>
//                 <div className="col">
//                   <figure>
//                     <img
//                       className="img-fluid w-100"
//                       src="/assets/images/img6.png"
//                       alt="neet"
//                     />
//                   </figure>
//                 </div>
//               </div>
//             </div>
//           </section>
//         </main>
//       </Layout>
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   const signInError = state.authentication.signInError;
//   const is_user = state.user.is_user;

//   return {
//     signInError: signInError,
//     is_user: is_user,
//   };
// };

// const mapDispatchToProps = (dispatch, state) => {
//   return {
//     signIn: (authentication, navigate) =>
//       dispatch(signInAction(authentication, navigate)),
//     socialSignin: (authentication, navigate) =>
//       dispatch(socialLoginAction(authentication, navigate)),
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(SignIn);




/////////////////////////////////////////////////////////////////////////


import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../utils/core/Layout";
import { useForm } from "react-hook-form";
import {
  DJANGO_CLIENT_ID,
  DJANGO_SECRET_ID,
  LINKEDIN_REDIRECT_URL,
} from "../../BackendConnections";
import { useLocation } from "react-router-dom";
import { useLinkedIn } from "react-linkedin-login-oauth2";
import {
  signInAction,
  socialLoginAction,
} from "../../redux/actions/authentication/authenticationAction";
import ReactLoading from "react-loading";
import { connect } from "react-redux";

export const SignIn = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //     if (localStorage.getItem('access_token') && props.is_user === true) {
  //         navigate('/user/dashboard')
  //     }
  // }, [props, navigate]);

  // Form submission handling.

    useEffect(() => {
    const css = `
      /* Make the feature icons behave nicely on all widths */
      .sign-in-page .features-list-block .features-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        padding-top: 40px;
        list-style: none;
        margin: 0;
      }

      /* Center the left block text on smaller screens */
      @media (max-width: 1199.98px) {
        .sign-in-page .features-list-block {
          text-align: center;
        }
        .sign-in-page .features-list-block h2 {
          margin-bottom: 16px;
        }
      }

      /* Tablets + small desktops (iPad, Nest Hub, etc.) */
      @media (max-width: 1199.98px) and (min-width: 768px) {
        /* stop any vertical centering weirdness */
        .sign-in-page .login-area .row.align-items-center {
          align-items: flex-start !important;
        }

        /* push the form clearly below the icons and center it */
        .sign-in-page .login-area .login-form {
          margin-top: 52px;
          max-width: 420px;
          margin-left: auto;
          margin-right: auto;
        }
      }
    `;

    const style = document.createElement("style");
    style.innerHTML = css;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);


  const onSubmit = (data, event) => {
    event.preventDefault();
    const authentication = {
      username: data.email.toLowerCase(),
      password: data.password,
      grant_type: "password",
      client_id: DJANGO_CLIENT_ID,
      client_secret: DJANGO_SECRET_ID,
    };

    if (Object.keys(errors).length === 0) {
      // setIsLoading(!isLoading)
      props.signIn(authentication, navigate);
    }
  };

  const { linkedInLogin } = useLinkedIn({
    clientId: "86jn3pqhdopvtf",
    redirectUri: LINKEDIN_REDIRECT_URL,
    scope: "r_emailaddress r_liteprofile",
    onSuccess: (code) => {
      props.socialSignin(code, navigate);
      setIsLoading(!isLoading);
    },
    onError: (error) => {
      this.setState({
        error: "Invalid Email / Invalid Password",
      });
    },
  });

  return (
    // <div className="login-page">
    <div className="login-page sign-in-page">

      {isLoading ? (
        <div
          style={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: "9999",
            opacity: 0.5,
          }}
        >
          <ReactLoading type={"bars"} color="#1D2552" />
        </div>
      ) : (
        ""
      )}
      <Layout>
        <main>
          <section className="login-area">
            <div className="container">
              {/* <div className="row"> */}
              <div className="row align-items-center">
                {/*<div className="col-md-6 mini-7"> */}
                <div className="col-12 col-xl-7">
                  <div className="inner-content features-list-block">
                    <h2>
                      Welcome to <br />a new era
                    </h2>
                    <p>
                      {/* Intro to the log in / sign up if required. Intro to the
                      log in / sign up if required. Intro to the log in / sign
                      up if required.{" "} */}

     Log In and continue to enhance your prospects and your energy
     sector journey.
                    </p>
                    <ul className="features-list">
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/profile.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>Profile</strong>
                        </div>
                      </li>
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/analytics.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>Analytics</strong>
                        </div>
                      </li>
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/network.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>Network</strong>
                        </div>
                      </li>
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/performance.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>Performance</strong>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <div className="col-md-6 mini-5"> */}
                <div className="col-12 col-xl-5">
                  <div className="login-form">
                      {/* Display a success message if present in the location state. */}
                    {location.state && (
                      <p style={{ color: "green", fontSize: "14px" }}>
                        {location.state.Message}
                      </p>
                    )}
                    <h5>Log In to Your Account</h5>
                    {/* Display an error message if there's a sign-in error from Redux state. */}
                    {props.signInError && (
                      <p style={{ color: "red", fontSize: "14px" }}>
                        {props.signInError.error_description}
                      </p>
                    )}
                     {/* Form handling using react-hook-form onSubmit event. */}
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="input-group">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Email"
                          autoComplete="off"
                          {...register("email", {
                            required: "Email is Required",
                            pattern: {
                              value:
                                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
                              message: "Email is not Valid",
                            },
                          })}
                        />
                      </div>
                       {/* Display validation error for the email input. */}
                      {errors.email ? (
                        <p style={{ color: "red", fontSize: "14px" }}>
                          {errors.email?.message}
                        </p>
                      ) : (
                        ""
                      )}
                      <div className="input-group table-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="Password"
                          autoComplete="off"
                          {...register("password", {
                            required: "Password is Required",
                          })}
                        />
                        <div className="input-group-append">
                          <Link
                            to=""
                            onClick={() => setShowPassword(!showPassword)}
                            className="btn btn-outline-secondary"
                          >
                            Show
                          </Link>
                        </div>
                      </div>
                      {errors.password ? (
                        <p style={{ color: "red", fontSize: "14px" }}>
                          {errors.password?.message}
                        </p>
                      ) : (
                        ""
                      )}

                      <div className="login-linkedin">
                        <button type="submit" className="btn btn-secondary">
                          Log in
                        </button>
                        &nbsp;
                        <Link
                          to="/forgetPassword"
                          style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "flex-end",
                            textDecoration: "underline",
                          }}
                        >
                          Forgot Password
                        </Link>
                      </div>
                    </form>
                    <h5>REGISTER FOR AN ACCOUNT</h5>
                    <Link to="/signup" className="btn btn-signup">
                      Sign up
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="img-list">
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img2.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img3.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img4.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img5.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img6.png"
                      alt="neet"
                    />
                  </figure>
                </div>
              </div>
            </div>
          </section>
        </main>
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => {
  const signInError = state.authentication.signInError;
  const is_user = state.user.is_user;

  return {
    signInError: signInError,
    is_user: is_user,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    signIn: (authentication, navigate) =>
      dispatch(signInAction(authentication, navigate)),
    socialSignin: (authentication, navigate) =>
      dispatch(socialLoginAction(authentication, navigate)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);

